import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import "./css/index.css";
import App from "./App";
import Forums from "./routes/forums";
import Topics from "./routes/topics";
import Posts from "./routes/posts";

const bodyEl = document.body;
bodyEl.classList.add("bg-slate-200");

const rootEl = document.getElementById("root");
rootEl.classList.add("h-full");
const root = ReactDOM.createRoot(rootEl);

const toTop = () => {
  window.scrollTo(0, 0);
};

document.body.addEventListener('click', evt => {
  if (evt.target.tagName === "A") {
    toTop();
  }
});

root.render(
  <div>
    <div className={"max-w-screen-lg mx-auto p-4 pt-0"}>
      <div className="flex flex-wrap content-center items-center py-4 border-b-2 border-slate-300 bg-slate-200 sticky top-0 z-10">
        <a href={process.env.PUBLIC_URL}>
          <img src={`./hpcc-logo_2022.png`} width={160} alt="HPCC Systems Logo" />
        </a>
        <h1 className="ml-4 grow">Forum Archive</h1>
        <p className="max-w-lg text-sm mt-2">
          <b className="text-red-600">Please Note:</b> The HPCC Systems forums have moved to Stack Overflow.
          We invite you to post your questions on Stack Overflow utilizing the tag <a className="font-bold" href="https://stackoverflow.com/search?tab=newest&q=hpcc-ecl" target="_blank">hpcc-ecl</a>.
        </p>
      </div>
      <BrowserRouter basename={process.env.PUBLIC_URL}>
        <Routes>
          <Route path="/" element={<App />}>
            <Route path="forums" element={<Forums />}>
              <Route path=":forumId/topics" element={<Topics />}>
                <Route path=":topicId" element={<Posts />} />
              </Route>
            </Route>
            <Route path="search" element={<Posts />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
    <div className="sticky bottom-16 right-10">
      <a id="toTop" onClick={toTop} className="fixed no-underline cursor-pointer bottom-4 right-4 bg-slate-700 text-white rounded-md px-6 py-3">Back to Top</a>
    </div>
    <p className="hidden">HPCC Systems - HPCC Community Forum - hpccsystems.com</p>
  </div>
);
